import styled, { css } from 'styled-components';

export const CartPreviewStyled = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;

        @media ${theme.mediaQueries.queryVl} {
            flex-direction: row;
            align-items: baseline;
            justify-content: flex-end;
            margin-top: 0;
            margin-bottom: 4px;
        }
    `,
);

export const CartPreviewTextStyled = styled.div`
    line-height: 24px;

    font-size: 18px;
`;

export const CartPreviewTotalPriceStyled = styled.div(
    ({ theme }) => css`
        margin: 12px 0;
        line-height: 18px;

        color: ${theme.color.green};
        font-size: 36px;
        font-weight: 700;

        @media ${theme.mediaQueries.queryVl} {
            margin: 0 0 0 10px;
        }
    `,
);
